import React from "react";
import TextField from "@mui/material/TextField";
import Tooltip from "./Tooltip";

export default function TooltipInput(props) {
  const { tip, slotProps, ...rest } = props;
  const ariaLabel =
    slotProps?.htmlInput?.["aria-label"] || tip || rest.label;

  return (
    <Tooltip tip={tip || rest.label}>
      <TextField
        {...rest}
        slotProps={{
          ...slotProps,
          htmlInput: {
            ...(slotProps?.htmlInput),
            "aria-label": ariaLabel,
          },
        }}
      />
    </Tooltip>
  );
}
